// Get Environment

const getEnv = (key, buildTimeVal) => {
  return (window._env_ && window._env_[key] !== undefined) ? window._env_[key] : buildTimeVal;
};

const ENV_CONFIG = {
  dev: {
    BASE_URL: getEnv("REACT_APP_BASE_URL_DEV", process.env.REACT_APP_BASE_URL_DEV),
  },
  staging: {
    BASE_URL: getEnv("REACT_APP_BASE_URL_STAGING", process.env.REACT_APP_BASE_URL_STAGING),
  },
  preprod: {
    BASE_URL: getEnv("REACT_APP_BASE_URL_PREPROD", process.env.REACT_APP_BASE_URL_PREPROD),
  },
  production: {
    BASE_URL: getEnv("REACT_APP_BASE_URL_PROD", process.env.REACT_APP_BASE_URL_PROD),
  },
};

const getCurrentServer = () => getEnv("REACT_APP_SERVER", process.env.REACT_APP_SERVER);

const getEnvironment = () => {
  const server = getCurrentServer();

  if (!server) {
    throw new Error("Environment variables is not defined!");
  }

  return ENV_CONFIG[server];
};

export const REPORTS_API_URL = process.env.REACT_APP_REPORTS_API_URL;
export const DSA_API_URL = process.env.REACT_APP_DSA_API_URL;
export const DSA_X_API_KEY = process.env.REACT_APP_DSA_X_API_KEY;
export const DSA_X_API_SECRET = process.env.REACT_APP_DSA_X_API_SECRET;
export const LENTRA_API_URL = process.env.REACT_APP_LENTRA_API_URL;
export const LENTRA_API_KEY_B64 = process.env.REACT_APP_LENTRA_API_KEY_B64;
export const LENTRA_API_SECRET_B64 = process.env.REACT_APP_LENTRA_API_SECRET_B64;
export const DOWNLOAD_ONLY_QUICK_REPORTS = process.env.REACT_APP_DOWNLOAD_ONLY_QUICK_REPORTS ? process.env.REACT_APP_DOWNLOAD_ONLY_QUICK_REPORTS
  .split(",").map(item => item.trim()) : [];
export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL;
export const SIGNOZ_INGESTION_REGION = process.env.REACT_APP_SIGNOZ_INGESTION_REGION;
export const SIGNOZ_INGESTION_KEY = process.env.REACT_APP_SIGNOZ_INGESTION_KEY;
export const SIGNOZ_SERVICE_NAME = process.env.REACT_APP_SIGNOZ_SERVICE_NAME;
export const SEND_SIGNOZ_TRACES = process.env.REACT_APP_SEND_SIGNOZ_TRACES || 0;
export const SIGNOZ_DEPLOYMENT_ENV = process.env.REACT_APP_SIGNOZ_DEPLOYMENT_ENV;
export const SIGNOZ_OTEL_TRACES_SAMPLER = process.env.REACT_APP_SIGNOZ_OTEL_TRACES_SAMPLER || 0.001;

export { getCurrentServer, getEnvironment };
